/**
 * DPR frontend entry.
 * - 부트스트랩: Application 클래스 (공통 + 라우트 디스패치).
 * - 레이아웃: layouts/main.php 의 data-controller / data-action, data-site-text-motion.
 */
import { Application } from "./Application";

function boot(): void {
    new Application().boot();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
} else {
    boot();
}
